import { create } from "zustand";
import { transferCusUpload, validateData } from "../api_layer/api";

export const useTransferCustomerUpload = create((set) => ({
  ValidateData: [],
  validateLoading: false,
  uploadLoading:false,
  isError: false,
  errorMessage: "",
  getValidateData: async (payload) => {
    try {
      set({ validateLoading: true, error: null });
      const response = await validateData(payload);
      set({ validateData: response.data, validateLoading:false });
    } catch (error) {
      set({ error: error.message });
    } finally {
      set({ validateLoading: false });
    }
  },
  postTransferCustomerUpload: async (payload, setToaster, handleClear) => {
    try {
      set({ uploadLoading: true, error: null });
      const response = await transferCusUpload(payload);
      set({ uploadLoading:false });
      setToaster("Transfer Customer", "Customer Transfer Successfully", "success");
      handleClear();
    } catch (error) {
      setToaster("Transfer Customer", "Customer Transfer Successfully", "danger");
      handleClear();
      set({ error: error.message , uploadLoading: false });
    } 
  },
}));
